import { Schema } from 'effect';

import { GtmItemsArraySchema } from './items';
import { Number } from '../primitive/number';
import { StringRequired } from '../primitive/string';

/**
 * https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#add_or_remove_an_item_from_a_shopping_cart
 */
export const GtmAddToCartEventSchema = Schema.Struct({
  event: Schema.Literal('track.add_to_cart'),
  ecommerce: Schema.Struct({
    currency: StringRequired,
    value: Number,
    items: GtmItemsArraySchema,
  }),
}).annotate({ identifier: 'GtmAddToCartEventSchema' });

export type GtmAddToCartEvent = Schema.Schema.Type<typeof GtmAddToCartEventSchema>;
